var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeartFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 28,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#EF776E",
  fillRule: "evenodd",
  d: "M12.1 25.47a82 82 0 0 1-8.55-8.287A13.4 13.4 0 0 1 .056 8.916a7.95 7.95 0 0 1 1.786-6.023A7.99 7.99 0 0 1 7.445.031a10.37 10.37 0 0 1 7.57 2.868 9.47 9.47 0 0 1 7.59-2.868c5.233.458 7.51 4.562 7.39 8.885a13.3 13.3 0 0 1-3.515 8.267 78 78 0 0 1-8.548 8.287L15.015 28z",
  clipRule: "evenodd"
})));
export default SvgHeartFilled;